import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet";
import { canonicalUrl } from '../siteConfig';
import { Card } from 'primereact/card';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

export default function () {
  return (
    <div style={{ backgroundColor: "#f8f9fa" }}>
      <Helmet>
        <title>Our Team | Solace Integrations | Westchester, NY</title>
        <link rel="canonical" href={canonicalUrl('/team')} />
        <meta name="description" content="Meet the team behind Solace Integrations. Network and infrastructure design professionals serving small and mid-sized businesses in Westchester and Fairfield Counties." />
      </Helmet>
      <Header isFixed />
      <div style={{ minHeight: "123px" }} ></div>

      <section className="team-section">
        <div className="container">
          <div className="title-content text-center mb-5">
            <h6 className="solace-title-subhny mb-2">Who We Are</h6>
            <h3 className="title-w3l">Our Team</h3>
          </div>

          <Card className="team-profile-card">
            <div className="profile-grid">
              <div className="profile-image-section">
                <div className="image-container">
                  <img 
                    src="assets/images/christian.jpg" 
                    alt="Christian Musial"
                    className="profile-image"
                  />
                  <div className="tech-overlay">
                    <div className="tech-badges">
                      <span className="tech-badge"><i className="pi pi-server"></i>Networking</span>
                      <span className="tech-badge"><i className="pi pi-cloud"></i>Cloud Technology</span>
                      <span className="tech-badge"><i className="pi pi-code"></i>IT Systems</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="profile-content">
                <div className="profile-header">
                  <h2 className="profile-name">Christian Musial</h2>
                  <div className="profile-role">Founder and Owner</div>
                </div>
                
                <div className="profile-details">
                  <div style={{ display: "flex", gap: "32px", marginBottom: "24px", flexWrap: "wrap", justifyContent: "center" }}>
                    <div>
                      <p style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", color: "#999", margin: "0 0 4px" }}>Education</p>
                      <p style={{ fontWeight: 600, fontSize: "14px", color: "#1a1f36", margin: 0 }}>B.S. Computer Science, University of Maryland</p>
                    </div>
                    <div>
                      <p style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", color: "#999", margin: "0 0 4px" }}>Certification</p>
                      <p style={{ margin: 0 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#eaf1fb", color: "var(--primary-color)", fontWeight: 600, fontSize: "13px", padding: "4px 10px", borderRadius: "4px" }}>
                          <i className="fas fa-id-badge"></i> CompTIA Network+
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="bio-section">
                    <p>
                      Christian Musial graduated with a B.S. in Computer Science from the University of Maryland in 2019.
                      Christian has over 5 years of IT and related experience, spanning a broad range of disciplines, such as software engineering,
                      web development, systems administration, audio-video, and computer networking.
                    </p>
                    <p>
                      He has worked across multiple industries such as healthcare, government, financial, and for residential clients.
                      He is also certified in computer networking, holding the Network+ certification from CompTIA.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      <section style={{ background: "#f0f4f8", padding: "48px 0", textAlign: "center" }}>
        <div className="container">
          <h4 style={{ marginBottom: "12px", fontWeight: 700 }}>Ready to work together?</h4>
          <p style={{ color: "#666", marginBottom: "24px", fontSize: "16px" }}>
            Reach out to discuss your project and find out how we can help.
          </p>
          <a href="/contact" className="btn btn-style solace-btn-primary">Contact Us</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
